module.exports = __webpack_public_path__ + "img/logo@2x.72e88d82.png";